import styled from "styled-components";

export const StyledGeneratePaymentWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`

export const StyledPaymentBox = styled.div`
  max-width: 600px;
  margin: 0px auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  .status {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    position: relative;
    background: ${(props) => props.background};
    flex-direction: column;
  }
  .status-text {
    font-weight: 700;
    color: ${(props) => props.color};
    width: 100%;
    padding: 1rem 1rem 5px;
    display: flex;
    align-items: center;
  }
  .pay-again {
    background: #2817f0;
    border: none;
    color: #fff;
    padding: 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    position: absolute;
    top: 10%;
    right: 10px;
  }
  .pay-again:disabled {
    background-color: #cccccc;
    color: #666;
  }
  .details {
    font-size: 14px;
    color: #333;
    line-height: 1.6;
    word-break: break-all;
    padding: 0 1rem 1rem;
  }

  @media(min-width: 800px){
    min-width: 500px;
  }
`;

